import * as React from 'react';

import { Messages } from '../../../codegen/Localize';
import { ContentClickedEventHandler } from '../../../common/telemetryEvents/types/ContentTelemetryTypes';
import { mouseUpFactory } from '../../../common/telemetryEvents/util/EventHandlerFactories';
import { L10n } from '../../../ts/L10n/L10n';
import { DataSources } from '../../../ts/resources/Datasources';
import { ExtractEncryptionMode } from '../../../ts/resources/Sites';
import { telemetryConsumerWrapper } from '../../contexts/TelemetryConsumerWrapper';
import { ContentClickedTelemetryContext } from '../../contexts/TelemetryContexts';
import { SiteUrlsProps } from '../../selectors/SiteUrlsSelectors';
import { CommonDatasourceInfo } from '../CommonDatasourceInfo';
import { CardViewStyles } from './CardViewStyles';

export interface DetailedDatasourceThumbnailOwnProps {
  readonly datasource: CommonDatasourceInfo;
  readonly contentUrl: string;
  readonly showExtractEncryptionStatus: boolean;
  readonly hoveredOrSelected?: boolean;
}

export interface DetailedDatasourceThumbnailStateProps {
  readonly siteEARMode: ExtractEncryptionMode;
}

export type DetailedDatasourceThumbnailProps =
  SiteUrlsProps & DetailedDatasourceThumbnailOwnProps & DetailedDatasourceThumbnailStateProps;

export class DetailedDatasourceThumbnail extends React.Component<DetailedDatasourceThumbnailProps> {
  public render() {
    const containerClass = this.props.hoveredOrSelected ?
      (this.props.contentUrl ? CardViewStyles.CustomThumbnailHover : CardViewStyles.CustomThumbnailHoverNoPointer)
      : CardViewStyles.CustomThumbnail;
    return (
      <div className={containerClass}>
        <div>
          <div className={CardViewStyles.CustomThumbnailTopContainer}>
            <div className={CardViewStyles.DatasourceCustomThumbnailImg}>
                <img
                  src={DataSources.getIconForDatasourceType(this.props.datasource, 'card')}
                  width={'60px'} height={'60px'}
                  data-tb-test-id={DataSources.isCertified(this.props.datasource) ? 'certification-icon' : ''}/>
            </div>
            <div>
              {DataSources.isExtract(this.props.datasource) ? DataSources.ExtractStatus(this.props.showExtractEncryptionStatus, this.props.siteEARMode, this.props.datasource.extractEncryptionState) : Messages.live()}
            </div>
          </div>
          <div>
            {this.lastRefreshTime()}
          </div>
        </div>
        {this.props.contentUrl &&
          telemetryConsumerWrapper(ContentClickedTelemetryContext.Consumer, (sendOpenContentTelemetry: ContentClickedEventHandler) =>
            <a onMouseUp={mouseUpFactory<HTMLAnchorElement>(sendOpenContentTelemetry)} href={this.props.contentUrl} className={CardViewStyles.AnchorUnderlay}></a>
          )
        }
      </div>
    );
  }
  private lastRefreshTime = (): JSX.Element => {
    const dateTime = this.props.datasource.lastRefreshedAt;
    return dateTime ? <span>{Messages.lastRefresh()} {L10n.localizedDateTime(dateTime)}</span> : <span>&nbsp;</span>;
  }
}
